import { Component, Input } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-disable-agree-disagree',
  templateUrl: './disable-agree-disagree.component.html',
  styleUrl: './disable-agree-disagree.component.css',
})
export class DisableAgreeDisagreeComponent {
  @Input() question!: Question;
}
